module.exports = __webpack_public_path__ + "static/images/containers/ChallengesPromo/images/points.bf4f133b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengesPromo/images/points.png
// module id = 2877
// module chunks = 11